import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    TextField,
    Typography,
    useTheme
} from "@mui/material";
import {useTranslation} from "react-i18next";
import '../../../style/SalesMarketing.css';
import * as React from "react";
import Box from "@mui/material/Box";
import {checkValueWithInterval} from "../../../component/Utils";
import {INTEGER_REG_EXP} from "../../../component/Constants";
import {useContext, useState} from "react";
import {useCouponActions} from "../../../service/useCouponActions";
import {GlobalContext} from "../../../../../util/state/GlobalContextProvider";
import {setSnackbar} from "../../../../../util/state/globalAction";
import {snackbarTypes} from "../../../../../util/state/globalVariables";

interface CouponCampaignAddCodesModalProps {
    open: boolean,
    handleClose: Function,
    couponCampaignId: any
}

const CouponCampaignAddCodesModal = ({
                                         open,
                                         handleClose,
                                         couponCampaignId
                                     }: CouponCampaignAddCodesModalProps) => {
    const {t} = useTranslation(['salesmarketing']);
    const theme = useTheme();
    const [quantityOfCodes, setQuantityOfCodes] = useState("")
    const {makeCoupons} = useCouponActions();
    const { dispatchGlobalData } = useContext(GlobalContext);

    const CONFIRM_SNACKBAR = {
        type: setSnackbar,
        payload: {
            snackbar: {
                message: t('salesmarketing:coupon.addCodes.success'),
                type: snackbarTypes.success,
                show: true,
                autoClose: true,
            }
        }
    };

    const handleChangeQuantityOfCodes = (event: React.ChangeEvent<HTMLInputElement>) => {
        if(event.target.value === "" || INTEGER_REG_EXP.test(event.target.value)) {
            setQuantityOfCodes(checkValueWithInterval(event.target.value, 1, 100));
        }
    };

    const confirmAddCodes = () => {
        makeCoupons(couponCampaignId, quantityOfCodes).then(res => {
            handleClose(true);
            setQuantityOfCodes("");
            dispatchGlobalData(CONFIRM_SNACKBAR);
        })
    }

    return (
        <Dialog disableEscapeKeyDown maxWidth={"sm"} fullWidth={true} open={open}
                onClose={() => {
                    return;
                }}>
            <DialogTitle>
                <Box sx={{display: 'flex', alignItems: 'center'}}>
                    <Typography sx={{paddingLeft: "10px"}} fontWeight={"bold"} color={"primary"}>
                        {t('salesmarketing:coupon.addCodes.modalTitle')}
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2} sx={{padding: "15px"}} alignItems={"center"}>
                    <Grid item>
                        <TextField
                            fullWidth
                            name="quantityOfCodes"
                            label={t('salesmarketing:coupon.addCodes.quantityOfCodes')}
                            value={quantityOfCodes}
                            onChange={handleChangeQuantityOfCodes}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{backgroundColor: theme.palette.neutral.bright, padding: "15px"}}>
                <Button variant={"outlined"} color={"accent"}
                        onClick={() => {
                            handleClose();
                            setQuantityOfCodes("");
                        }}>
                    {t('salesmarketing:coupon.buttons.cancel')}
                </Button>
                <Button disabled={!quantityOfCodes} color={"accent"} onClick={() => {
                    confirmAddCodes();
                }}>
                    {t('salesmarketing:coupon.addCodes.confirmButton')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default CouponCampaignAddCodesModal;